import React from 'react';
import {
    Stepper,
    Step,
    StepLabel,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import {
    CheckCircle,
    RadioButtonUnchecked,
    Settings,
    WorkOutline
} from '@mui/icons-material';

// Custom icon component for each step
const CustomStepIcon = ({ active, completed }) => {
    if (completed) return <CheckCircle sx={{ color: '#2196f3' }} />;
    if (active) return <Settings color="secondary" />;
    return <RadioButtonUnchecked color="disabled" />;
};

// Stepper component
export const CustomStepper = ({ steps, activeStep }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const getDisplayedSteps = () => {
        // Always attach actualIndex
        const stepsWithIndex = steps.map((step, index) => ({
            ...step,
            actualIndex: index
        }));

        if (!isMobile) return stepsWithIndex;

        let start = Math.max(0, activeStep - 1);
        let end = Math.min(steps.length, start + 3);

        if (end - start < 3 && start > 0) {
            start = Math.max(0, end - 3);
        }

        return stepsWithIndex.slice(start, end);
    };

    const displayedSteps = getDisplayedSteps();

    const mobileActiveStep = isMobile
        ? displayedSteps.findIndex((s) => s.actualIndex === activeStep)
        : activeStep;

    return (
        <Stepper activeStep={mobileActiveStep} alternativeLabel sx={{ mb: 1 }}>
            {displayedSteps.map((step) => (
                <Step key={step.id} completed={step.actualIndex < activeStep}>
                    {isMobile == true ?
                        <StepLabel StepIconComponent={CustomStepIcon}>
                            {step.display}
                        </StepLabel>
                        :
                        <StepLabel></StepLabel>
                    }
                </Step>
            ))}
        </Stepper>
    );
};
